import { render } from "./3.LimousineServices.vue?vue&type=template&id=831464d0&scoped=true"
import script from "./3.LimousineServices.vue?vue&type=script&lang=js"
export * from "./3.LimousineServices.vue?vue&type=script&lang=js"

import "./3.LimousineServices.vue?vue&type=style&index=0&id=831464d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-831464d0"]])

export default __exports__